export const formatHandicapForDisplay = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  const num = parseFloat(String(value))
  if (isNaN(num)) {
    return ''
  }

  if (num < 0) {
    return `+${Math.abs(num).toFixed(1)}`
  }

  return num.toFixed(1)
}

export const parseHandicapInput = (displayValue: unknown): number | null => {
  if (displayValue === null || displayValue === undefined || displayValue === '') {
    return null
  }

  const trimmed = String(displayValue).trim().replace(',', '.')
  if (trimmed === '' || trimmed === '+' || trimmed === '-') {
    return null
  }

  if (trimmed.startsWith('+')) {
    const absValue = parseFloat(trimmed.substring(1))
    if (isNaN(absValue)) {
      return null
    }
    return -absValue
  }

  const num = parseFloat(trimmed)
  if (isNaN(num)) {
    return null
  }

  return num
}
